import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { HowItWorksSection } from '../components/HowItWorksSection';
import { AppMockupSection } from '../components/AppMockupSection';
import { WhyDifferentSection } from '../components/WhyDifferentSection';
import { MetaPixel } from '../components/MetaPixel';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <>
      <MetaPixel data-id="element-241" />
      <main className="min-h-screen w-full bg-[#FAF8F5] font-sans text-[#3A3A3A] overflow-x-hidden relative" data-id="element-242">
        {/* Noise Texture Overlay */}
        <div className="fixed inset-0 pointer-events-none opacity-[0.03] z-50 mix-blend-multiply" style={{
        backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.65' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)'/%3E%3C/svg%3E")`
      }} data-id="element-243" />

        <HeroSection data-id="element-244" />
        <ProblemSection data-id="element-245" />
        <HowItWorksSection data-id="element-246" />
        <AppMockupSection data-id="element-247" />
        <WhyDifferentSection data-id="element-248" />
      </main>
      <Footer data-id="element-249" />
    </>;
}